import gsap from "gsap";
import { Clock } from "three";
import { AnimationMixer } from "three";
import { Mesh } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import model from "../../assets/models/GLB_Angelopolis_Iconos_V08.glb";
import { getUrlParamZone } from "../../utils/urlParams";

export class GltfIcons extends Mesh {
  constructor(loadingManager) {
    super();
    let loader = new GLTFLoader(loadingManager);
    this.allModel;
    this.allMesh = [];
    this.clock = new Clock();
    this.mixer;
    this.onLoadModel(loader);
    this.scale.set(1, 1, 1);
    this.position.set(120, -8, -290);
  }
  onLoadModel(loader) {
    loader.load(model, (gltf) => {
      this.add(gltf.scene);
      this.allModel = gltf.scene;
      this.mixer = new AnimationMixer(gltf.scene);
      this.arrows = [
        gltf.scene.getObjectByName("Acceso1_flecha_MT_G_iconos_0"),
        gltf.scene.getObjectByName("Acceso2_flecha_MT_G_iconos_0"),
        gltf.scene.getObjectByName("Acceso3_flecha_MT_G_iconos_0"),
      ];
      gltf.animations.forEach((clip) => {
        this.mixer.clipAction(clip).play();
      });
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.material.transparent = true;
          this.allMesh.push(child);
        }
      });
      if (getUrlParamZone()) {
        this.hidenModelComplete();
      }
      this.hiddenArrows();
    });
  }

  hidenModelComplete() {
    this.allMesh.map((mesh) => {
      gsap.to(mesh.material, {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          // this.allModel.visible = false;
        },
      });
    });
  }
  showModelComplete() {
    this.allMesh.map((mesh) => {
      gsap.to(mesh.material, {
        opacity: 1,
        duration: 1.5,
        onStart: () => {
          // this.allModel.visible = true;
        },
      });
    });
  }
  showArrows() {
    this.arrows.map((arrow) => {
      arrow.visible = true;
      arrow.scale.set(0.1, 0.1, 0.1);
      gsap
        .timeline()
        .to(arrow.position, { duration: 1, ease: "back.out(1.2)" })
        .to(
          arrow.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            duration: 1,
            onComplete: () => {
              // arrow.visible = false;
            },
            ease: "back.out(1.2)",
          },
          "-=1"
        );
    });
  }

  hiddenArrows() {
    this.arrows.map((arrow) => {
      gsap
        .timeline()
        .to(arrow.position, { duration: 1, ease: "back.out(1.2)" })
        .to(
          arrow.scale,
          {
            x: 0.1,
            y: 0.1,
            z: 0.1,
            duration: 1,
            ease: "back.out(1.2)",
            onComplete: () => {
              arrow.visible = false;
            },
          },
          "-=1"
        );
    });
  }

  renderAnimations() {
    let delta = this.clock.getDelta();
    if (this.mixer) this.mixer.update(delta);
  }
}
